<template>
  <scale-loader
    :loading="props.loading"
    :color="loaderColor"
    :height="props.small ? '17px' : props.xSmall ? '14px' : '35px'"
    :width="props.small ? '2px' : props.xSmall ? '1px' : undefined"
  ></scale-loader>
</template>
<script setup>
import { computed } from "vue";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import { useDomain } from "@/composable/useDomain.js";

const { isFreshWater } = useDomain();

const props = defineProps({
  loading: Boolean,
  small: Boolean,
  xSmall: Boolean,
  color: {
    type: String,
    default: null,
  },
});

const loaderColor = computed(() => {
  if (props.color) return props.color;
  return isFreshWater.value ? "#41C969" : "#1052D8";
});
</script>
